import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

export default function getRecurrenceFromList(idList) {
  const url = `${process.env.P2C_BASE_URI}/requests/recurrence`;
  return Client.post(
    url,
    { properties: idList },
    {
      __retry: { nbLeft: 2, timeout: 2000 },
    }
  )
    .then((response) => {
      return response.data.recurrence;
    })
    .catch(errorHandler);
}
